import { t } from "./i18n";

export function invitationUrl(
  code: string,
  pageUrl = location.href,
  lanHost = import.meta.env.DEV ? import.meta.env.VITE_DEV_LAN_HOST : "",
): string {
  const url = new URL(pageUrl);
  if (lanHost && ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname))
    url.hostname = lanHost;
  url.search = "";
  url.hash = "";
  url.searchParams.set("room", code);
  return url.href;
}

const images = new Map<string, Promise<string>>();

export async function renderInvitationQr(host: HTMLElement, code: string): Promise<void> {
  const url = invitationUrl(code);
  host.setAttribute("role", "img");
  host.setAttribute("aria-label", t("QR code pour rejoindre le salon {code}", { code }));
  try {
    let image = images.get(url);
    if (!image) {
      if (images.size >= 16) images.delete(images.keys().next().value!);
      image = import("qrcode").then(({ default: qr }) => qr.toString(url, {
        type: "svg", errorCorrectionLevel: "M", margin: 4,
        color: { dark: "#102233", light: "#ffffff" },
      }));
      images.set(url, image);
    }
    const svg = await image;
    if (!host.isConnected) return;
    host.innerHTML = svg;
    host.querySelector("svg")?.setAttribute("aria-hidden", "true");
  } catch {
    images.delete(url);
    if (host.isConnected) {
      host.removeAttribute("role");
      host.removeAttribute("aria-label");
      host.textContent = t("QR code indisponible. Utilise le code du salon.");
    }
  }
}
